import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { HeaderProgressTracker } from '../Common/HeaderStepper/HeaderProgressTracker';
import * as Steps from './steps';
import { getSessionStorageItem, getBasicInfo, storeConsumerApplicationId, SESSION_STORAGE_AFLAC_QUOTE, SESSION_STORAGE_ACCOUNT_KEY } from '../../../sessionStorage';
import './Aflac.scss';
import {
    MARYLAND, VIRGINIA, CALIFORNIA, CONNECTICUT, DISTRICT_OF_COLUMBIA, MINNESOTA,
    PENNSYLVANIA, VERMONT, ARIZONA, COLORADO, MAINE, OREGON, MONTANA, NEVADA,
    DELAWARE, NEWHAMPSHIRE, RHODE_ISLAND, WASHINGTON, WISCONSIN, NEW_YORK, NEW_JERSEY, VIRGIN_ISLANDS, ALABAMA, ALASKA, ARKANSAS, FLORIDA, GEORGIA, HAWAII, IOWA, ILLINOIS, INDIANA, KANSAS, KENTUCKY, MICHIGAN, MISSISSIPPI, NORTH_CAROLINA, NORTH_DAKOTA, NEBRASKA, OKLAHOMA, SOUTH_CAROLINA, SOUTH_DAKOTA, TENNESSEE, TEXAS, WYOMING
} from "../../Helpers/Constants/States";
import Age from '../../Helpers/Dates/Age';
import { Container, Col } from "react-bootstrap";
import { CircularProgress } from '@mui/material';
import { IneligiblePerson, IneligibleOptions } from "./Helpers/Constant";
import './Aflac.scss';

export default function Aflac(props) {
    const { path } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const prefill = location && location.search && location.search.toLowerCase().includes('prefill');
    const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_AFLAC_QUOTE);
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const basicInfo = getBasicInfo();
    
    const defaultCoverageAmountOptions = [
        { value: "500", label: "$500" },
        { value: "1000", label: "$1000" },
        { value: "1500", label: "$1500" },
        { value: "2000", label: "$2000" }
    ];

    const getCoverageAmountOptions = (state) => {
        let benefitAmount = [];
        const coverageAmountOptions = [];
        const hospitalConfinementBenefitAmounts = accountObj.hospitalConfinementBenefitAmounts;
        benefitAmount = hospitalConfinementBenefitAmounts && hospitalConfinementBenefitAmounts.length > 0 && hospitalConfinementBenefitAmounts.map(x => x.benefitAmount);
        if(benefitAmount.length > 0){
            for(let i = 0; i < benefitAmount.length; i++ ){
                if((state === CONNECTICUT && benefitAmount[i] === 500)){
                    continue;
                }
                else{
                    coverageAmountOptions.push({ value: benefitAmount[i].toString(), label: `$${benefitAmount[i]}` });
                }
            }
        }
        if(coverageAmountOptions.length > 0){
            return coverageAmountOptions;
        }
        else{
            return defaultCoverageAmountOptions;
        }
    };
    if (props.landing && sessionStorageFormState) {
        sessionStorageFormState.currentStep = 1;
    }
    const [loading, setLoading] = useState(false);
    const mentalIllnessFacilityStates = [ALASKA, ALABAMA, ARKANSAS, COLORADO, DISTRICT_OF_COLUMBIA, FLORIDA, GEORGIA, HAWAII, IOWA, ILLINOIS, INDIANA, KANSAS, KENTUCKY, MAINE, MICHIGAN, MISSISSIPPI, NORTH_CAROLINA, NORTH_DAKOTA, NEBRASKA, OKLAHOMA, SOUTH_CAROLINA, SOUTH_DAKOTA, TENNESSEE, TEXAS, WISCONSIN, WYOMING];
    const showEligiblityScreenState = [CALIFORNIA, CONNECTICUT, DISTRICT_OF_COLUMBIA, MINNESOTA, PENNSYLVANIA, VERMONT];
    const stateForBenificaryScreen = [MARYLAND, VIRGIN_ISLANDS];
    const stateForHIVScreen = [ARIZONA, COLORADO, MARYLAND, MAINE, OREGON];
    const stateForSevenYearScreen = [MARYLAND, MONTANA, NEVADA, VERMONT];
    const stateForThirdPartyScreen = [MAINE];
    const stateForChildInfoScreen = [NEW_YORK];
    const showSpouseScreenPlan = ['namedSpousePremium', 'twoParentFamilyPremium'];
    const showChildScreenPlan = ['oneParentFamilyPremium', 'twoParentFamilyPremium'];
    const newDefaultFormState = {
        currentStep: 1,
        policyNumber: "",
        steps: {
            basicInfo: Steps.BasicInfo.DefaultFormState(prefill, basicInfo),
            splashPage: Steps.SplashPage.DefaultFormState(prefill, basicInfo),
            importantBenifits: Steps.ImportantBenifits.DefaultFormState(prefill, basicInfo),
            quoter: Steps.Quoter.DefaultFormState(prefill, basicInfo, getCoverageAmountOptions(basicInfo.state)[0].value),
            eligibility: Steps.Eligibility.DefaultFormState(prefill, basicInfo),
            personalInfo: Steps.InsuredInfo.DefaultFormState(prefill, basicInfo),
            spouseInfo: Steps.SpouseInfo.DefaultFormState(prefill),
            childInfo: Steps.ChildInfo.DefaultFormState(prefill, basicInfo),
            replacingInfo: Steps.ReplacingInfo.DefaultFormState(prefill, basicInfo),
            medicalEligibility: Steps.MedicalEligibility.DefaultFormState(prefill, basicInfo),
            hivEligibility: Steps.HIVEligibility.DefaultFormState(prefill, basicInfo),
            sevenYearEligibility: Steps.SevenYearEligibility.DefaultFormState(prefill, basicInfo),
            fiveYearEiligibility: Steps.FiveYearEiligibility.DefaultFormState(prefill, basicInfo),
            threeYearEligibility: Steps.ThreeYearEligibility.DefaultFormState(prefill, basicInfo),
            paymentInfo: Steps.PaymentInfo.DefaultFormState(prefill, basicInfo),
            electronicDelivery: Steps.ElectronicDelivery.DefaultFormState(prefill, basicInfo),
            // submissionReview: Steps.SubmissionReview.DefaultFormState(prefill, basicInfo),
            ineligibility: Steps.Ineligibility.DefaultFormState(prefill),
            thirdPartyDemographic: Steps.ThirdPartyDemoGraphic.DefaultFormState(prefill, basicInfo),
            beneficiary: Steps.Beneficiary.DefaultFormState(prefill),
        },
        relatedFinancialInstitution: accountObj.account.accountName,
        //submittingAgentCode: loanProtProductSettings ? loanProtProductSettings.submittingAgentCode : 'CVR99B ',
        productType: "Aflac",
        adminMode: false,
        adminCode: "",
        decisionResponse: null,
        fieldsChangedAfterUnderwriting: [],
        oneClickAccountId: accountObj.account.oneClickAccountId,
        consumerAccountId: accountObj.account.accountId,
        sessionId: accountObj.sessionId,
    };
    const initialFormState = sessionStorageFormState || newDefaultFormState;
    const [formState, setFormState] = useState(initialFormState);
    const ageSpecs = { min: 18, max: 65 };
    const accountId = accountObj.account.accountId;
    const insuredPersonFullName = `${formState.steps.personalInfo.lastName} ${formState.steps.personalInfo.firstName} ${formState.steps.personalInfo.middleInitial}`;
    const spouseFullName = `${formState.steps.spouseInfo.lastName} ${formState.steps.spouseInfo.firstName} ${formState.steps.spouseInfo.middleInitial}`;
    const insuredIneligibleOptionLabel = IneligibleOptions.INSURED;
    const spouseIneligibleOptionLabel = IneligibleOptions.SPOUSE;
    useEffect(
        () => {
            if (!path) {
                return;
            }

            const nextStep = steps.find(s => s.path === path);

            if (!nextStep || formState.currentStep === nextStep.step) {
                return;
            }
            const newFormState = { ...formState, currentStep: nextStep.step };
            setFormState(newFormState);
        }, [path]);

    const changeEligibility = (stateToSet) => {
        stateToSet.steps.quoter.plan = formState.steps.ineligibility.plan;
        stateToSet.steps.quoter.planAmount = formState.steps.ineligibility.planAmount;
        stateToSet.steps.quoter.premiumWithoutRider = formState.steps.ineligibility.premiumWithoutRider;
        stateToSet.steps.quoter.extendedBenefitRiderPremium = formState.steps.ineligibility.extendedBenefitRiderPremium;
        stateToSet.steps.quoter.hospitalStayAndSurgicalCareRiderPremium = formState.steps.ineligibility.hospitalStayAndSurgicalCareRiderPremium;
        if (formState.steps.ineligibility.ineligiblePerson === IneligiblePerson.SPOUSE
            || (formState.steps.ineligibility.ineligiblePerson === IneligiblePerson.CHILD && (formState.steps.ineligibility.plan === "individualPremium" || formState.steps.ineligibility.plan === "namedSpousePremium"))
            || (formState.steps.ineligibility.ineligiblePerson === IneligiblePerson.CHILD_SPOUSE && formState.steps.ineligibility.plan === "individualPremium")) {

            if (formState.steps.ineligibility.ineligiblePerson === IneligiblePerson.SPOUSE || (formState.steps.ineligibility.ineligiblePerson === "Both" && formState.steps.ineligibility.plan !== "individualPremium"))
                {stateToSet.steps.spouseInfo = Steps.SpouseInfo.DefaultFormState(prefill);}
            else if (formState.steps.ineligibility.ineligiblePerson === IneligiblePerson.CHILD)
                {stateToSet.steps.childInfo = Steps.ChildInfo.DefaultFormState(prefill);}
            else {
                stateToSet.steps.spouseInfo = Steps.SpouseInfo.DefaultFormState(prefill);
                stateToSet.steps.childInfo = Steps.ChildInfo.DefaultFormState(prefill);
            }
            stateToSet.steps.medicalEligibility.ineligible.map((element) => {
                const type = element.type;
                stateToSet.steps.medicalEligibility[type] = "no";
            });
            stateToSet.steps.medicalEligibility.ineligible = [];

            stateToSet.steps.fiveYearEiligibility.ineligible.map((element) => {
                const type = element.type;
                stateToSet.steps.fiveYearEiligibility[type] = "false";
            });
            stateToSet.steps.fiveYearEiligibility.none = "true";
            stateToSet.steps.fiveYearEiligibility.ineligible = [];

            stateToSet.steps.threeYearEligibility.ineligible.map((element) => {
                const type = element.type;
                stateToSet.steps.threeYearEligibility[type] = "false";
            });
            stateToSet.steps.threeYearEligibility.none = "true";
            stateToSet.steps.threeYearEligibility.ineligible = [];

            stateToSet.steps.sevenYearEligibility.ineligible.map((element) => {
                const type = element.type;
                stateToSet.steps.sevenYearEligibility[type] = "false";
            });
            stateToSet.steps.sevenYearEligibility.none = "true";
            stateToSet.steps.sevenYearEligibility.ineligible = [];

            stateToSet.steps.hivEligibility.ineligible.map((element) => {
                const type = element.type;
                stateToSet.steps.hivEligibility[type] = "No";
            });
            stateToSet.steps.hivEligibility.ineligible = [];
            stateToSet.steps.ineligibility.ineligiblePerson = "";
            stateToSet.steps.ineligibility.ineligiblePersonName = "";
        }
        else if ((formState.steps.ineligibility.ineligiblePerson === IneligiblePerson.CHILD_SPOUSE && formState.steps.ineligibility.plan !== "individualPremium")) {

            stateToSet.steps.spouseInfo = Steps.SpouseInfo.DefaultFormState(prefill);
            const arrayOfMedical = [];
            const arrayOfFiveYearEligibilty = [];
            const arrayOfSevenYearEligibility = [];
            const arrayOfThreeYearEligibility = [];
            const arrayOfHivEligibility = [];
            const ineligiblity = [];
            stateToSet.steps.medicalEligibility.ineligible.map((element, index) => {
                if ((element.name.includes(spouseIneligibleOptionLabel)) && element.name.length === 1) {
                    const type = element.type;
                    stateToSet.steps.medicalEligibility[type] = "no";
                }
                else {
                    if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length > 1)
                        {element.name = element.name.filter(x => x !== spouseIneligibleOptionLabel);}
                    ineligiblity.push(element);
                    arrayOfMedical.push(element);
                }
            });
            stateToSet.steps.medicalEligibility.ineligible = arrayOfMedical;

            stateToSet.steps.fiveYearEiligibility.ineligible.map((element) => {
                if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length === 1) {
                    const type = element.type;
                    stateToSet.steps.fiveYearEiligibility[type] = "false";
                }
                else {
                    if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length > 1)
                        {element.name = element.name.filter(x => x !== spouseIneligibleOptionLabel);}
                    ineligiblity.push(element);
                    arrayOfFiveYearEligibilty.push(element);
                }
            });
            if (arrayOfFiveYearEligibilty.length <= 0) {
                stateToSet.steps.fiveYearEiligibility.none = "true";
            }
            stateToSet.steps.fiveYearEiligibility.ineligible = arrayOfFiveYearEligibilty;

            stateToSet.steps.threeYearEligibility.ineligible.map((element) => {
                if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length === 1) {
                    const type = element.type;
                    stateToSet.steps.threeYearEligibility[type] = "false";
                }
                else {
                    if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length > 1)
                        {element.name = element.name.filter(x => x !== spouseIneligibleOptionLabel);}
                    ineligiblity.push(element);
                    arrayOfThreeYearEligibility.push(element);
                }
            });
            if (arrayOfThreeYearEligibility.length <= 0) {
                stateToSet.steps.threeYearEligibility.none = "true";
            }
            stateToSet.steps.threeYearEligibility.ineligible = arrayOfThreeYearEligibility;

            stateToSet.steps.sevenYearEligibility.ineligible.map((element) => {
                if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length === 1) {
                    const type = element.type;
                    stateToSet.steps.sevenYearEligibility[type] = "false";
                }
                else {
                    if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length > 1)
                        {element.name = element.name.filter(x => x !== spouseIneligibleOptionLabel);}
                    ineligiblity.push(element);
                    arrayOfSevenYearEligibility.push(element);
                }
            });
            if (arrayOfSevenYearEligibility.length <= 0) {
                stateToSet.steps.sevenYearEligibility.none = "true";
            }
            stateToSet.steps.sevenYearEligibility.ineligible = arrayOfSevenYearEligibility;

            stateToSet.steps.hivEligibility.ineligible.map((element) => {
                if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length === 1) {
                    const type = element.type;
                    stateToSet.steps.hivEligibility[type] = "No";
                }
                else {
                    if (element.name.includes(spouseIneligibleOptionLabel) && element.name.length > 1)
                        {element.name = element.name.filter(x => x !== spouseIneligibleOptionLabel);}
                    ineligiblity.push(element);
                    arrayOfHivEligibility.push(element);
                }
            });
            stateToSet.steps.hivEligibility.ineligible = arrayOfHivEligibility;
            const inelibilePersonDetail = getInelibilePersonDetail(ineligiblity);
            stateToSet.steps.ineligibility.ineligiblePersonName = inelibilePersonDetail.ineligiblePersonName;
        }

        return stateToSet;
    };
    
    const onNext = () => {

        const currentStep = steps.find(s => s.step === formState.currentStep);
        let stateToSet = formState;
        if (currentStep.path === 'medical-ineligibility') {
            stateToSet = changeEligibility(stateToSet);
        }
        let nextStep = steps.find(s => s.step === formState.currentStep + 1);
        if (nextStep.path === 'important-benefits' && formState.steps.basicInfo.hsaAccount) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }

        if (nextStep.path === 'eligibility' && !(showEligiblityScreenState.includes(formState.steps.basicInfo.state))) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'ineligibility' && !(findIneligibilityByBasicInfo() !== null)) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'spouse-info' && !(showSpouseScreenPlan.includes(formState.steps.quoter.plan))) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'child-info' && !(showChildScreenPlan.includes(formState.steps.quoter.plan) && stateForChildInfoScreen.includes(formState.steps.basicInfo.state))) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'beneficiary' && !(stateForBenificaryScreen.includes(formState.steps.basicInfo.state))) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'medical-eligibility' && !(isGuaranteedIssue() === "No")) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'hiv-eligibility' && !(isGuaranteedIssue() === "No" && stateForHIVScreen.includes(formState.steps.basicInfo.state))) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'seven-year-eligibility' && !(isGuaranteedIssue() === "No" && stateForSevenYearScreen.includes(formState.steps.basicInfo.state))) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'five-year-eligibility' && !(isGuaranteedIssue() === "No")) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'three-year-eligibility' && !(isGuaranteedIssue() === "No")) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'medical-ineligibility' && !(findIneligibility() !== null)) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (nextStep.path === 'third-party' && !(stateForThirdPartyScreen.includes(formState.steps.basicInfo.state))) {
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (!nextStep) {
            throw new Error("onNext did not find a next step");
        }
        const newFormState = { ...stateToSet, currentStep: nextStep.step };
        if (nextStep.step > 7) {
            const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
            fetch(`${covrServicesUrl}/api/ConsumerApplication/Post?accountId=${accountId}&productType=Supplemental Health`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'SessionId': accountObj.sessionId,
                    'X-Consumer-Application-ID': accountObj.consumerApplicationId,
                },
                body: JSON.stringify(newFormState)
            }).then(storeConsumerApplicationId);
        }
        setFormState(newFormState);
        sessionStorage.setItem(SESSION_STORAGE_AFLAC_QUOTE, JSON.stringify(newFormState));

        navigate(`/quote/aflac/hospital-confinement/${nextStep.path}`);
        window.scroll(0, 0);
    };
    const onBack = () => {
        let backStep = steps.find(s => s.step === formState.currentStep - 1);
        if (backStep.path === 'third-party' && !(stateForThirdPartyScreen.includes(formState.steps.basicInfo.state))) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'medical-ineligibility' && !(findIneligibility() !== null)) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'three-year-eligibility' && !(isGuaranteedIssue() === "No")) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'five-year-eligibility' && !(isGuaranteedIssue() === "No")) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'seven-year-eligibility' && !(isGuaranteedIssue() === "No" && stateForSevenYearScreen.includes(formState.steps.basicInfo.state))) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'hiv-eligibility' && !(isGuaranteedIssue() === "No" && stateForHIVScreen.includes(formState.steps.basicInfo.state))) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'medical-eligibility' && !(isGuaranteedIssue() === "No")) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'beneficiary' && !(stateForBenificaryScreen.includes(formState.steps.basicInfo.state))) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'child-info' && !(showChildScreenPlan.includes(formState.steps.quoter.plan) && stateForChildInfoScreen.includes(formState.steps.basicInfo.state))) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'spouse-info' && !(showSpouseScreenPlan.includes(formState.steps.quoter.plan))) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'ineligibility' && !(findIneligibilityByBasicInfo() !== null)) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'eligibility' && !(showEligiblityScreenState.includes(formState.steps.basicInfo.state))) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }
        if (backStep.path === 'important-benefits' && formState.steps.basicInfo.hsaAccount) {
            backStep = steps.find((s) => s.step === backStep.step - 1);
        }

        if (!backStep) {
            throw new Error("onBack did not find a previous step");
        }

        const newFormState = { ...formState, currentStep: backStep.step };

        setFormState(newFormState);
        sessionStorage.setItem(SESSION_STORAGE_AFLAC_QUOTE, JSON.stringify(newFormState));

        navigate(`/quote/aflac/hospital-confinement/${backStep.path}`);
        window.scroll(0, 0);
    };
    const goToStep = (path) => {
        const newSteps = formState.steps;
        const nextStep = steps.find(s => s.path === path);
        if (!nextStep) {
            throw new Error("goToStep did not find a next step");
        }

        const newFormState = { ...formState, steps: newSteps, currentStep: nextStep.step };

        setFormState(newFormState);
        sessionStorage.setItem(SESSION_STORAGE_AFLAC_QUOTE, JSON.stringify(newFormState));

        navigate(`/quote/aflac/hospital-confinement/${nextStep.path}`);
        window.scroll(0, 0);
    };
    const getHeaderTextForState = () => {
        const state = formState.steps.basicInfo && formState.steps.basicInfo.state;
        switch(state){
            case DISTRICT_OF_COLUMBIA:
                return "Supplemental Only Insurance";
            case PENNSYLVANIA:
                return "Supplemental Hospital";
            default:
                return "Hospital Confinement Indemnity Insurance";
        }
    };
    const getHeaderText = () => {
        const currentStep = formState.currentStep;
        if (currentStep === 4) {
            return "Let’s find the best quote for you";
        }
        else {
            return getHeaderTextForState();
        }
    };
    const hideMainTitle = () => {
        const currentStep = formState.currentStep;
        if (currentStep === 1 || currentStep === 2 || currentStep === 4) {
            return true;
        }
        return false;
    };

    const onFieldChange = (step, field, value) => {
        setFormState({ ...formState, steps: { ...formState.steps, [step]: { ...formState.steps[step], [field]: value } } });
    };

    const onStepFieldChange = (step, field, value, field2, value2) => {
        setFormState({ ...formState, steps: { ...formState.steps, [step]: { ...formState.steps[step], [field]: value, [field2]: value2 } } });
    };

    const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
        const stepPer = ((step - 1) / totalStep * 100);
        const cateCount = currentCateTotalStep === 1 ? 1 : (((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep));
        return stepPer + cateCount;
    };

    const isGuaranteedIssue = () => {
        if (formState.steps.basicInfo && formState.steps.basicInfo.hsaAccount) {
            return "No";
        }
        else if (formState.steps.basicInfo && !formState.steps.basicInfo.hsaAccount && formState.steps.quoter.hospitalStayAndSurgicalCareRider) {
            return "No";
        }
    };

    const downloadPDF = (option, filename) => {
        const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
        setLoading(true);
        fetch(`${covrServicesUrl}/api/Aflac/getBrochure?option=${option}&filename=${filename}`)
            .then(response => {
                response.blob().then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.target = "_blank";
                    a.href = url;
                    a.click();
                    setLoading(false);
                }).catch(() => {
                    setLoading(false);
                });
            }).catch(() => setLoading(false));
    };

    const findIneligibilityByBasicInfo = () => {

        let ineligiblePerson, ineligiblePersonName, childIneligibleName, spouseIneligibleName;

        const basicInfoEligibleState = [DELAWARE, NEWHAMPSHIRE, RHODE_ISLAND, WASHINGTON, VIRGINIA, NEW_JERSEY, "PR"];
        const basicInfoAge = formState.steps.basicInfo.birthdate && Age(formState.steps.basicInfo.birthdate);
        const eligibilityState = formState.steps.eligibility;

        if ((formState.steps.basicInfo.state && basicInfoEligibleState.includes(formState.steps.basicInfo.state)) || (basicInfoAge && (basicInfoAge <= 17 || basicInfoAge >= 65))) {
            ineligiblePerson = IneligiblePerson.INSURED;
            ineligiblePersonName = "Proposed Insured";

        }

        else if ((showEligiblityScreenState.includes(formState.steps.basicInfo.state)) && (
            eligibilityState.employmentStatus === "No" || 
            ((eligibilityState.acknowledgementMinimum === "No" || eligibilityState.acknowledgementLimited === "No") && formState.steps.basicInfo.state === DISTRICT_OF_COLUMBIA) ||
            (eligibilityState.existingHealthInsurance === "No" && (formState.steps.basicInfo.state === CALIFORNIA || formState.steps.basicInfo.state === DISTRICT_OF_COLUMBIA || formState.steps.basicInfo.state === MINNESOTA || formState.steps.basicInfo.state === PENNSYLVANIA || formState.steps.basicInfo.state === VERMONT)) || 
            (eligibilityState.existingMedicare ==="Yes" && (formState.steps.basicInfo.state === CALIFORNIA || formState.steps.basicInfo.state === MINNESOTA)) ||
            eligibilityState.existingMediCal ==="Yes")) {
            ineligiblePerson = IneligiblePerson.INSURED;
            ineligiblePersonName = "Proposed Insured";
        }
        else {
            return null;
        }

        if (!ineligiblePerson) {return null;}
        return { ineligiblePerson, ineligiblePersonName, childIneligibleName, spouseIneligibleName };
    };

    const getInelibilePersonDetail = (medicalIneligible, ineligiblityByBasicInfo = false) => {
        const insuredInfo = formState.steps.personalInfo;
        const spouseInfo = formState.steps.spouseInfo;
        const insuredPersonName = `${insuredInfo.firstName} ${insuredInfo.lastName}`;
        const spouseName = `${spouseInfo.firstName} ${spouseInfo.lastName}`;
        let ineligiblePerson, ineligiblePersonName;
        let proposedInsured = false;
        let proposedSpouse = false;
        let dependentChild = false;
        const dependentChildNames = [];
        let childIneligibleName = "";
        let spouseIneligibleName = "";
        let childData = "";

        medicalIneligible.map((element, i) => {
            if (element.name.includes("Myself") || element.name.includes(insuredPersonFullName))
                {proposedInsured = true;}
            if (element.name.includes("Spouse") || element.name.includes(spouseFullName))
                {proposedSpouse = true;}
            if (element.name.includes("Dependent Child")) {
                medicalIneligible[i].nameofChildren.map((child) => {
                    if (!dependentChildNames.includes(child.name))
                        {dependentChildNames.push(child.name);}
                });
                dependentChild = true;
            }
        });
        if (dependentChildNames.length > 0) {
            dependentChildNames.map((name, index) => {
                if (dependentChildNames.length - 1 === index && dependentChildNames.length >= 2) {
                    childData = `${childData} and ${name}`;
                }
                else if (dependentChildNames.length - 2 === index) {
                    childData = `${childData} ${name}`;
                }
                else if (dependentChildNames.length !== 1) {
                    childData = `${name}, ${childData}`;
                }
                else {
                    childData = name;
                }
            });
        }
        if (proposedInsured) {
            ineligiblePerson = IneligiblePerson.INSURED;
            ineligiblePersonName = insuredPersonName;
        }
        else if (proposedSpouse && dependentChild) {

            ineligiblePersonName = ineligiblityByBasicInfo ? dependentChildNames.join(', ') : `${dependentChildNames.join(', ')} and ${spouseName}`;
            ineligiblePerson = IneligiblePerson.CHILD_SPOUSE;
            childIneligibleName = dependentChildNames;
            spouseIneligibleName = spouseName;
        }
        else if (proposedSpouse) {
            ineligiblePersonName = spouseName;
            ineligiblePerson = IneligiblePerson.SPOUSE;
            spouseIneligibleName = spouseName;
        }
        else if (dependentChild) {
            ineligiblePersonName = childData;
            childIneligibleName = dependentChildNames;
            ineligiblePerson = IneligiblePerson.CHILD;
        }
        return { ineligiblePersonName: ineligiblePersonName, ineligiblePerson: ineligiblePerson, childIneligibleName, spouseIneligibleName };
    };
    const findIneligibility = () => {

        let ineligiblePerson, ineligiblePersonName;
        const arrayOfIneligiblePerson = [];

        let isChildInEligible = [];
        if (formState.steps.childInfo.dependentChild[0].dateOfBirth) {
            let childIndex;
            if (formState.steps.basicInfo.state === WISCONSIN) {
                childIndex = formState.steps.childInfo.dependentChild.map((child, index) => Age(child.dateOfBirth) >= 26 ? index : '');
            } else {
                childIndex = formState.steps.childInfo.dependentChild.map((child, index) => Age(child.dateOfBirth) > 26 ? index : '');
            }
            isChildInEligible = childIndex.filter((child) => child !== "");
        }

        if (formState.steps.personalInfo.employmentStatus === "No") {
            arrayOfIneligiblePerson.push({
                name: [insuredPersonFullName],
                nameofChildren: [],
                numberOfChildren: "",
                type: "employmentStatus",
            });

        } if (showSpouseScreenPlan.includes(formState.steps.quoter.plan) && formState.steps.spouseInfo.hospitalized === "Yes") {
            arrayOfIneligiblePerson.push({
                name: [spouseFullName],
                nameofChildren: [],
                numberOfChildren: "",
                type: "hospitalized",
            });

        } if (showChildScreenPlan.includes(formState.steps.quoter.plan) && isChildInEligible && isChildInEligible.length > 0) {
            ineligiblePerson = IneligiblePerson.CHILD;
            ineligiblePersonName = `${formState.steps.childInfo.dependentChild[isChildInEligible[0]].firstName} ${formState.steps.childInfo.dependentChild[isChildInEligible[0]].lastName}`;

            const name = [];
            isChildInEligible.map((index) => name.push({ name: `${formState.steps.childInfo.dependentChild[index].firstName} ${formState.steps.childInfo.dependentChild[index].lastName}` }));
            arrayOfIneligiblePerson.push({
                name: ["Dependent Child"],
                nameofChildren: name,
                numberOfChildren: `${isChildInEligible} child`,
                type: "age",
            });

        }
        if (formState.steps.replacingInfo.existingCoverageWithAflac === "Yes") {
            arrayOfIneligiblePerson.push({
                name: [insuredPersonFullName],
                nameofChildren: [],
                numberOfChildren: "",
                type: "existingCoverageWithAflac",
            });
        }
        if (isGuaranteedIssue() === "No" && formState.steps.medicalEligibility.ineligible.length > 0) { // medicalEligibility
            const medicalIneligible = formState.steps.medicalEligibility.ineligible;
            medicalIneligible.map((element) => arrayOfIneligiblePerson.push(element));
        }
        if ((isGuaranteedIssue() === "No" && stateForHIVScreen.includes(formState.steps.basicInfo.state)) && formState.steps.hivEligibility.ineligible.length > 0 && ((formState.steps.basicInfo.state === COLORADO && formState.steps.hivEligibility.hivSubstantiated === "Yes") || formState.steps.basicInfo.state !== COLORADO)) { // hivEligibility
            const hivInEligible = formState.steps.hivEligibility.ineligible;
            hivInEligible.map((element) => arrayOfIneligiblePerson.push(element));
        }
        if ((isGuaranteedIssue() === "No" && stateForSevenYearScreen.includes(formState.steps.basicInfo.state)) && formState.steps.sevenYearEligibility.ineligible.length > 0) { // sevenYearEligibility
            const sevenYearInEligible = formState.steps.sevenYearEligibility.ineligible;
            sevenYearInEligible.map((element) => arrayOfIneligiblePerson.push(element));
        }
        if ((isGuaranteedIssue() === "No") && formState.steps.fiveYearEiligibility.ineligible.length > 0) { // fiveYearEiligibility
            const fiveYearInEligible = formState.steps.fiveYearEiligibility.ineligible;
            fiveYearInEligible.map((element) => arrayOfIneligiblePerson.push(element));
        }
        if ((isGuaranteedIssue() === "No") && formState.steps.threeYearEligibility.ineligible.length > 0) { // threeYearEligibility
            const threeYearInEligible = formState.steps.threeYearEligibility.ineligible;
            threeYearInEligible.map((element) => arrayOfIneligiblePerson.push(element));
        }
        let spouseIneligibleName = "";
        let childIneligibleName = "";
        const objectOFDetails = getInelibilePersonDetail(arrayOfIneligiblePerson);
        ineligiblePerson = objectOFDetails.ineligiblePerson;
        ineligiblePersonName = objectOFDetails.ineligiblePersonName;
        childIneligibleName = objectOFDetails.childIneligibleName;
        spouseIneligibleName = objectOFDetails.spouseIneligibleName;
        if (!ineligiblePerson) {return null;}

        return { ineligiblePerson, ineligiblePersonName, childIneligibleName, spouseIneligibleName };
    };
    const getListOfPlanIncludedPerson = () => {
        const options = [
            { value: insuredIneligibleOptionLabel, label: insuredPersonFullName },
        ];
        if (formState.steps.quoter.plan && showSpouseScreenPlan.includes(formState.steps.quoter.plan)) {
            options.push({ value: spouseIneligibleOptionLabel, label: spouseFullName });
        }

        if (formState.steps.quoter.plan && showChildScreenPlan.includes(formState.steps.quoter.plan)) {
            options.push({ value: 'Dependent Child', label: 'Dependent Child' });
        }
        return options;
    };
    const handlePaymentComplete = (appId, policyEffectiveDate) => {
        setFormState({ ...formState, appIdentifier: appId, policyEffectiveDate: policyEffectiveDate });
    };

    const steps = [
        {
            step: 1,
            path: 'basic-info',
            progressTitle: 'Basic Information',
            component: (
                <Steps.BasicInfo
                    formState={formState.steps.basicInfo}
                    onFieldChange={(field, value) => onFieldChange('basicInfo', field, value)}
                    onNext={onNext}
                    hideBack={props.landing}
                    ageSpecs={ageSpecs}
                    onBack={() => { }}
                />
            ),
            hideProgressTracker: true,
        },
        {
            step: 2,
            path: 'splash-page',
            progressTitle: 'Splash page',
            component: (
                <Steps.SplashPage
                    formState={formState.steps.splashPage}
                    onFieldChange={(field, value) => onFieldChange('splashPage', field, value)}
                    onNext={onNext}
                    fullFormState={formState}
                    onBack={() => navigate('/landing/hospital')}
                    headerText={getHeaderTextForState()}
                    basicInfo={formState.steps.basicInfo}
                    coverageAmountOptions={() => getCoverageAmountOptions(formState.steps.basicInfo.state)}
                    downloadPDF={(option, state) => downloadPDF(option, state)}
                    mentalIllnessFacilityStates={mentalIllnessFacilityStates}
                />
            ),
            hideProgressTracker: true,
        },
        {
            step: 3,
            path: 'important-benefits',
            progressTitle: "Coverage Details",
            component: (
                <Steps.ImportantBenifits
                    formState={formState.steps.importantBenifits}
                    onFieldChange={(field, value) => onFieldChange('importantBenifits', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    basicInfo={formState.steps.basicInfo}
                    downloadPDF={(option, state) => downloadPDF(option, state)}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 1,
            categoryStep: 1,
        },
        {
            step: 4,
            path: 'quoter',
            progressTitle: 'Quoter',
            component: (
                <Steps.Quoter
                    importantBenifits={formState.steps.importantBenifits}
                    formState={formState.steps.quoter}
                    onFieldChange={(field, value) => onFieldChange('quoter', field, value)}
                    onNext={onNext}
                    onBack={() => navigate('/landing/hospital')}
                    basicInfo={formState.steps.basicInfo}
                    coverageAmountOptions={() => getCoverageAmountOptions(formState.steps.basicInfo.state)}
                    downloadPDF={(option, state) => downloadPDF(option, state)}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    fullFormState={formState}
                    mentalIllnessFacilityStates={mentalIllnessFacilityStates}
                />
            ),
            hideProgressTracker: true,
        },
        {
            step: 5,
            path: 'eligibility',
            progressTitle: 'Eligibility',
            component: (
                <Steps.Eligibility
                    formState={formState.steps.eligibility}
                    onFieldChange={(field, value) => onFieldChange('eligibility', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    quoter={formState.steps.quoter}
                    basicInfo={formState.steps.basicInfo}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('eligibility', field, value, field2, value2)}
                />
            ),
            categoryNumber: 3,
            categoryStep: 2,
            hideProgressTracker: false,
        },
        {
            step: 6,
            path: 'ineligibility',
            progressTitle: 'Ineligibility',
            component: (
                <Steps.Ineligibility
                    formState={formState.steps.ineligibility}
                    basicInfo={formState.steps.basicInfo}
                    selectedPlan={formState.steps.quoter.plan}
                    onFieldChange={(field, value) => onFieldChange('ineligibility', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    ineligible={findIneligibilityByBasicInfo}
                    quoter={formState.steps.quoter}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('ineligibility', field, value, field2, value2)}
                    fullFormState={formState}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                />
            ),
            categoryNumber: 3,
            categoryStep: 2,
            hideProgressTracker: false,
        },
        {
            step: 7,
            path: 'getting-started',
            progressTitle: 'Getting Started',
            component: (
                <Steps.GettingStarted
                    onNext={onNext}
                    onBack={onBack}
                />
            ),
            hideProgressTracker: false,
            hideStepText: true,
        },
        {
            step: 8,
            path: 'insured-info',
            progressTitle: "Insured's Information",
            component: (
                <Steps.InsuredInfo
                    state={formState.steps.basicInfo.state}
                    formState={formState.steps.personalInfo}
                    basicInfo={formState.steps.basicInfo}
                    onFieldChange={(field, value) => onFieldChange('personalInfo', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('personalInfo', field, value, field2, value2)}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 1,
            categoryStep: 1,
        },
        {
            step: 9,
            path: 'spouse-info',
            progressTitle: "Spouse's Information",
            component: (
                <Steps.SpouseInfo
                    formState={formState.steps.spouseInfo}
                    onFieldChange={(field, value) => onFieldChange('spouseInfo', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    ageSpecs={ageSpecs}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 2,
            categoryStep: 1,
        },
        {
            step: 10,
            path: 'child-info',
            progressTitle: "Child's Information",
            component: (
                <Steps.ChildInfo
                    formState={formState.steps.childInfo}
                    onFieldChange={(field, value) => onFieldChange('childInfo', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    basicInfo={formState.steps.basicInfo}
                />
            ),
            categoryNumber: 2,
            categoryStep: 2,
            hideProgressTracker: false,
        },
        {
            step: 11,
            path: 'beneficiary',
            progressTitle: "Beneficiary's Information",
            component: (
                <Steps.Beneficiary
                    formState={formState.steps.beneficiary}
                    onFieldChange={(field, value) => onFieldChange('beneficiary', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    fullFormState={formState}
                />
            ),
            categoryNumber: 2,
            categoryStep: 3,
            hideProgressTracker: false,
        },
        {
            step: 12,
            path: 'replacing-info',
            progressTitle: "Insured's Information",
            component: (
                <Steps.ReplacingInfo
                    formState={formState.steps.replacingInfo}
                    onFieldChange={(field, value) => onFieldChange('replacingInfo', field, value)}
                    onNext={onNext}
                    goToStep={() => goToStep("medical-ineligibility")}
                    onBack={onBack}
                    basicInfo={formState.steps.basicInfo}
                    setMultiField={(insurancePolicies, numberOfPolicies) => setFormState({ ...formState, steps: { ...formState.steps, replacingInfo: { ...formState.steps.replacingInfo, insurancePolicies: insurancePolicies, numberOfPolicies: numberOfPolicies } } })}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 2,
            categoryStep: 4,
        },
        {
            step: 13,
            path: 'medical-eligibility',
            progressTitle: 'Qualification Questions',
            component: (
                <Steps.MedicalEligibility
                    formState={formState.steps.medicalEligibility}
                    state={formState.steps.basicInfo.state}
                    noOfChilds={stateForChildInfoScreen.includes(formState.steps.basicInfo.state) && formState.steps.childInfo && formState.steps.childInfo.noOfDependentChildren}
                    onFieldChange={(field, value) => onFieldChange('medicalEligibility', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('medicalEligibility', field, value, field2, value2)}
                    getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 3,
            categoryStep: 2,
        },
        {
            step: 14,
            path: 'hiv-eligibility',
            progressTitle: 'Qualification Questions',
            component: (
                <Steps.HIVEligibility
                    formState={formState.steps.hivEligibility}
                    onFieldChange={(field, value) => onFieldChange('hivEligibility', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    basicInfo={formState.steps.basicInfo}
                    medicalEligibility={formState.steps.medicalEligibility}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('hivEligibility', field, value, field2, value2)}
                    getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
                    noOfChilds={stateForChildInfoScreen.includes(formState.steps.basicInfo.state) && formState.steps.childInfo && formState.steps.childInfo.noOfDependentChildren}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    fullFormState={formState}
                />
            ),
            categoryNumber: 3,
            categoryStep: 1,
            hideProgressTracker: false,
        },
        {
            step: 15,
            path: 'seven-year-eligibility',
            progressTitle: 'Qualification Questions',
            component: (
                <Steps.SevenYearEligibility
                    formState={formState.steps.sevenYearEligibility}
                    onFieldChange={(field, value) => onFieldChange('sevenYearEligibility', field, value)}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('sevenYearEligibility', field, value, field2, value2)}
                    onNext={onNext}
                    onBack={onBack}
                    basicInfo={formState.steps.basicInfo}
                    getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
                    noOfChilds={stateForChildInfoScreen.includes(formState.steps.basicInfo.state) && formState.steps.childInfo && formState.steps.childInfo.noOfDependentChildren}
                />
            ),
            categoryNumber: 3,
            categoryStep: 3,
            hideProgressTracker: false,
        },
        {
            step: 16,
            path: 'five-year-eligibility',
            progressTitle: 'Qualification Questions',
            component: (
                <Steps.FiveYearEiligibility
                    formState={formState.steps.fiveYearEiligibility}
                    onFieldChange={(field, value) => onFieldChange('fiveYearEiligibility', field, value)}
                    onNext={onNext}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('fiveYearEiligibility', field, value, field2, value2)}
                    onBack={onBack}
                    basicInfo={formState.steps.basicInfo}
                    getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
                    noOfChilds={stateForChildInfoScreen.includes(formState.steps.basicInfo.state) && formState.steps.childInfo && formState.steps.childInfo.noOfDependentChildren}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 3,
            categoryStep: 4,
        },
        {
            step: 17,
            path: 'three-year-eligibility',
            progressTitle: 'Qualification Questions',
            component: (
                <Steps.ThreeYearEligibility
                    formState={formState.steps.threeYearEligibility}
                    onFieldChange={(field, value) => onFieldChange('threeYearEligibility', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('threeYearEligibility', field, value, field2, value2)}
                    basicInfo={formState.steps.basicInfo}
                    getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
                    noOfChilds={stateForChildInfoScreen.includes(formState.steps.basicInfo.state) && formState.steps.childInfo && formState.steps.childInfo.noOfDependentChildren}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 3,
            categoryStep: 5,
        },
        {
            step: 18,
            path: 'medical-ineligibility',
            progressTitle: 'Ineligibility',
            component: (
                <Steps.Ineligibility
                    formState={formState.steps.ineligibility}
                    basicInfo={formState.steps.basicInfo}
                    onFieldChange={(field, value) => onFieldChange('ineligibility', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    ineligible={findIneligibility}
                    quoter={formState.steps.quoter}
                    selectedPlan={formState.steps.quoter.plan}
                    onStepFieldChange={(field, value, field2, value2) => onStepFieldChange('ineligibility', field, value, field2, value2)}
                    fullFormState={formState}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                />
            ),
            categoryNumber: 3,
            categoryStep: 2,
            hideProgressTracker: false,
        },
        {
            step: 19,
            path: 'third-party',
            progressTitle: 'Third Party Information',
            component: (
                <Steps.ThirdPartyDemoGraphic
                    formState={formState.steps.thirdPartyDemographic}
                    basicInfo={formState.steps.basicInfo}
                    onFieldChange={(field, value) => onFieldChange('thirdPartyDemographic', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                />
            ),
            categoryNumber: 3,
            categoryStep: 6,
            hideProgressTracker: false,
        },
        {
            step: 20,
            path: 'payment-info',
            progressTitle: 'Payment Information',
            component: (
                <Steps.PaymentInfo
                    formState={formState.steps.paymentInfo}
                    fullFormState={formState}
                    onFieldChange={(field, value) => onFieldChange('paymentInfo', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    noOfChilds={formState.steps.childInfo && formState.steps.childInfo.noOfDependentChildren}
                    getListOfPlanIncludedPerson={getListOfPlanIncludedPerson}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 4,
            categoryStep: 1,
        },
        {
            step: 21,
            path: 'electronic-delivery',
            progressTitle: 'Payment Information',
            component: (
                <Steps.ElectronicDelivery
                    formState={formState.steps.electronicDelivery}
                    onFieldChange={(field, value) => onFieldChange('electronicDelivery', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    handlePaymentComplete={handlePaymentComplete}
                    fullFormState={formState}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 5,
            categoryStep: 1,
        },
        {
            step: 22,
            path: 'sign',
            progressTitle: 'Sign',
            component: (
                <Steps.DocuSign
                    formState={formState}
                    onNext={onNext}
                    onBack={onBack}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 5,
            categoryStep: 2,
        },
        {
            step: 23,
            path: 'status',
            progressTitle: 'Application Complete',
            component: (
                <Steps.SubmissionReview
                    formState={formState}
                    onFieldChange={(field, value) => onFieldChange('submissionReview', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    quoter={formState.steps.quoter}
                />
            ),
            hideProgressTracker: false,
            categoryNumber: 5,
            categoryStep: 3,
        },

    ];

    const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
    const categories = steps.filter((o) => o.categoryNumber === currentStepObj.categoryNumber);
    const totalCategoriesStep = Math.max.apply(Math, categories.map((o) => { return o.categoryStep; }));
    const percent = calculatePercentage(formState.currentStep > 7 ? 5 : 3, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);
    return (
        <div className="aflac-hospital-confinement">
            <Helmet>
                <title>{`Health Confinement - ${currentStepObj?.categoryName || currentStepObj?.progressTitle}`}</title>
            </Helmet>
            {currentStepObj.path === "quoter" &&
                <div className="quoter-main-title">
                    <Container className="ps-0">
                        <Col sm={12}>
                            <span className="text-center mt-2 mb-2">Let’s find the best quote for you</span>
                        </Col>
                    </Container>
                </div>
            }
            {loading && <div className="main-loading-container">
                <CircularProgress />
            </div>}
            <HeaderProgressTracker
                title={getHeaderText()}
                hidden={props.landing || currentStepObj.hideMainHeader}
                hideProgressTracker={currentStepObj.hideProgressTracker}
                stepName={currentStepObj.categoryName || currentStepObj.progressTitle}
                displayStepTitleWithArrow={true}
                step={currentStepObj.categoryNumber || 0}
                totalSteps={formState.currentStep > 7 ? 5 : 3}
                lastStep={currentStepObj.lastStep}
                hideStepsDropdown={currentStepObj.hideStepsDropdown}
                percent={percent}
                currentPageTitle={true}
                hideMainTitle={hideMainTitle()}
                hideStepText={currentStepObj.hideStepText}
                displayHelpText={true}
                isblackHeaderText ={true}
            >
                <div>
                    {currentStepObj.component}
                </div>
            </HeaderProgressTracker>
        </div>
    );
}

Aflac.propTypes = {
    landing: PropTypes.bool,
};
